import React, { useState, useContext } from 'react';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-core';
import { getPublicationDisplayTitle } from '../../../api/UtilsApi';
import { Publication } from '@amzn/awscat-pattern-library-service-model';
import arraySort from 'array-sort';
import HomePageCtx from './HomePageCtx';
import { ContentSortDropdownId, RUMEventTracking } from '../../../monitoring';

enum ContentSortOption {
  NewToOld = 'Sort by newest to oldest date',
  OldToNew = 'Sort by oldest to newest date',
  AToZ = 'Sort by title A to Z',
  ZToA = 'Sort by title Z to A',
}

const ContentSortDropDown = () => {
  const { setFilteredPublications, filteredPublications } = useContext(HomePageCtx);
  const [selectedSortId, setSelectedSortId] = useState<ContentSortOption>(
    ContentSortOption.NewToOld,
  );

  const dropDownItems: ButtonDropdownProps.Items = [
    {
      text: ContentSortOption.NewToOld,
      id: ContentSortOption.NewToOld,
    },
    {
      text: ContentSortOption.OldToNew,
      id: ContentSortOption.OldToNew,
    },
    {
      text: ContentSortOption.AToZ,
      id: ContentSortOption.AToZ,
    },
    {
      text: ContentSortOption.ZToA,
      id: ContentSortOption.ZToA,
    },
  ];

  const handleSortClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    const eventId = event.detail.id as ContentSortOption;
    switch (eventId) {
      case ContentSortOption.NewToOld:
        arraySort(filteredPublications, 'lastUpdated', { reverse: true });
        break;
      case ContentSortOption.OldToNew:
        arraySort(filteredPublications, 'lastUpdated');
        break;
      case ContentSortOption.AToZ:
        arraySort(filteredPublications, (publication1: Publication, publication2: Publication) => {
          const title1 = getPublicationDisplayTitle(publication1);
          const title2 = getPublicationDisplayTitle(publication2);
          return title1.localeCompare(title2);
        });
        break;
      case ContentSortOption.ZToA:
        arraySort(filteredPublications, (publication1: Publication, publication2: Publication) => {
          const title1 = getPublicationDisplayTitle(publication1);
          const title2 = getPublicationDisplayTitle(publication2);
          return title2.localeCompare(title1);
        });
        break;
    }
    setFilteredPublications([...filteredPublications]);
    setSelectedSortId(eventId);
  };

  return (
    <ButtonDropdown
      onItemClick={handleSortClick}
      items={dropDownItems}
      className="home-page-content-sort-dropdown"
    >
      {selectedSortId}
    </ButtonDropdown>
  );
};

export default ContentSortDropDown;
